import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { HttpClient, HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { RequestInterceptor } from './core/interceptors/request.interceptor';
import { DataCollectorService } from './core/services/data_collector_services/data_collector_service.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoutAlertComponent } from './components/logout-alert/logout-alert.component';
import { MatIconModule } from '@angular/material/icon';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DispatchBoardSharedModule } from '../../projects/dispatch-board/src/app/app.module';
import { CalendarSharedModule } from '../../projects/job-calendar/src/app/app.module';
import { LightgalleryModule } from 'lightgallery/angular';
import { ZuperConfigModule } from '@zuper/services/config';
import { ZuperModule } from '@zuper';
import { BryntumCoreModule } from '@bryntum/core-angular-thin';
import { BryntumGanttModule } from '@bryntum/gantt-angular-thin';
import { BryntumGridModule } from '@bryntum/grid-angular-thin';
import { BryntumSchedulerModule } from '@bryntum/scheduler-angular-thin';
import { BryntumSchedulerProModule } from '@bryntum/schedulerpro-angular-thin';
import { ReportBuilderSharedModule } from '../../projects/report-builder/src/app/app.module';
import { WorkflowBuilderModule } from '../../projects/workflow-builder/src/app/app.module';
import { SettingsSharedModule } from '../../projects/settings/src/app/app.module';
import { FullScreenLoaderComponent } from './components/full-screen-loader/full-screen-loader.component';
import { SDKCustomDialogModule } from './components/sdk-custom-dialog/sdk-custom-dialog.module';
import { AiFabComponent } from './modules/ai/ai-fab.component';
import { ZuperConnectSharedModule } from '../../projects/zuper-connect/src/app/app.module';
import { DialerOverlayComponent } from "./modules/dialer/dialer-component/dialer-overlay.component";
import { CallMaskingInterceptor } from './core/interceptors/call-masking.interceptor';
import { ToastModule } from './components/toast/toast.module';
import { TourService } from './core/services/tour.service';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

export function playerFactory() {
  return player;
}

// AoT requires an exported function for factories
const httpLoaderFactory = (http: HttpClient): any => new TranslateHttpLoader(http, './assets/i18n/', '.json');


const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
};

@NgModule({
    declarations: [
        AppComponent,
        FullScreenLoaderComponent,
        LogoutAlertComponent
    ],
    imports: [
        BrowserModule,
        ToastModule,
        LightgalleryModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Zuper, ZuperConfig
        ZuperModule,
        ZuperConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        ReactiveFormsModule,
        FormsModule,
        MatIconModule,
        FullCalendarModule,
        BryntumCoreModule,
        BryntumGridModule,
        BryntumSchedulerModule,
        BryntumSchedulerProModule,
        BryntumGanttModule,
        SDKCustomDialogModule,
        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        WorkflowBuilderModule.forRoot(),
        DispatchBoardSharedModule.forRoot(),
        CalendarSharedModule.forRoot(),
        ReportBuilderSharedModule.forRoot(),
        ZuperConnectSharedModule.forRoot(),
        AiFabComponent,
        DialerOverlayComponent,
        SettingsSharedModule.forRoot()
    ],
    providers: [
        provideLottieOptions({ player: playerFactory }),
        DataCollectorService,
        TourService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CallMaskingInterceptor,
            multi: true
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
